<template>
  <wrapperLink
    class="long-links link-wrapper"
    :class="[{ 'type-navigation': navigation }, ['dir-' + navigation]]"
    :iconBg="theme.iconBG"
    :icoColor="theme.icons"
    :bgColor="theme.background"
    :txtColor="theme.text"
    :hoverIcon="theme.hoverIcon"
    :hoverIconBg="theme.hoverIconBG"
    :hovBg="theme.hoverBg"
  >
    <span class="text"><slot></slot></span>
    <span class="icon" v-html="IconItem"></span>
  </wrapperLink>
</template>

<script>
import styled from "vue-styled-components";

const wrapperProps = {
  icoColor: String,
  bgColor: String,
  txtColor: String,
  iconBg: String,
  hovBg: String,
  hoverIcon: String,
  hoverIconBg: String
};
const wrapperLink = styled("div", wrapperProps)`
  ${props =>
    props.txtColor && props.txtColor !== ""
      ? ".text a{color: " + props.txtColor + "!important}"
      : ""};
  ${props =>
    props.bgColor && props.bgColor !== ""
      ? ".text a{background-color: " + props.bgColor + "!important}"
      : ""};
  ${props =>
    props.iconBg && props.iconBg !== ""
      ? ".icon{background-color: " + props.iconBg + "!important }"
      : ""};
  ${props =>
    props.icoColor && props.icoColor !== ""
      ? "svg g{ fill: " + props.icoColor + "!important}"
      : ""};
  &:hover {
    ${props =>
      props.hovBg
        ? ".text a{ background: " + props.hovBg + " !important}"
        : ""};
    ${props =>
      props.hoverIcon ? "svg g{ fill: " + props.hoverIcon + "!important}" : ""};
    ${props =>
      props.hoverIconBg
        ? ".icon{background-color: " + props.hoverIconBg + "!important }"
        : ""};
    ${props =>
      props.hovBg ? ".text a{color: " + props.hoverIconBg + "!important}" : ""};
  }
`;

export default {
  name: "link-wrapper",
  props: {
    icon: String,
    navigation: String,
    link: String
  },
  components: {
    wrapperLink
  },
  computed: {
    IconItem() {
      if (this.icon) return this.icon;
      else return this.svgIcons.arrow2;
    },
    theme() {
      if (this.navigation && this.navigation !== "") {
        return {
          hoverBg: "#2A2E34",
          hoverIconBG: "#fff",
          hoverIcon: "#2A2E34",
          background: this.currentTheme().select_color,
          iconBG:
            this.currentTheme().text_color === "light" ? "#fff" : "#2A2E34",
          text: this.currentTheme().text_color === "light" ? "#fff" : "#2A2E34",
          icons: this.currentTheme().select_color
        };
      } else {
        return {
          hoverBg: this.currentTheme().select_color,
          hoverIconBG: "#fff",
          hoverIcon: this.currentTheme().select_color,
          background: "",
          text: "",
          icons: "#fff",
          iconBG: this.currentTheme().select_color
        };
      }
    }
  }
};
</script>

<style lang="scss">
@import "./../../assets/scss/mixins.scss";
@import "./../../assets/scss/vars.scss";

.long-links.link-wrapper {
  position: relative;
  .text {
    @include fluid-type($smallResText, $wideResText, 15px, 26px);
    font-weight: 800;
    color: inherit;
    a {
      display: block;
      padding: 20px;
      color: inherit;
      text-decoration: none;
    }
  }
}
</style>
